import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories, MAIN_SITE_URL } from '@/mocks/categories';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="mt-20 border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-table-line text-lg"></i>
              </span>
              <span className="font-heading text-base font-semibold text-foreground-950">
                {t('brand.name')}
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-600">
              {t('footer.disclaimer')}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t('footer.explore')}
            </h4>
            <ul className="mt-4 space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  {t('nav.home')}
                </Link>
              </li>
              <li>
                <Link to="/article/allchinabuy-spreadsheet-guide" className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer">
                  {t('nav.guide')}
                </Link>
              </li>
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer"
                >
                  {t('buttons.allchinabuySpreadsheet')}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-950">
              {t('footer.browseCategories')}
            </h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.key}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-600 hover:text-primary-700 cursor-pointer whitespace-nowrap"
                  >
                    {t('categories.' + cat.key)}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} {t('brand.name')}. {t('footer.rights')}
          </p>
          <Link to="/" className="text-xs text-foreground-500 hover:text-primary-700 cursor-pointer">
            {t('footer.backHome')}
          </Link>
        </div>
      </div>
    </footer>
  );
}